export default __webpack_public_path__ + "static/soehne-web-extrafett-1a4ea1e1e9a1106a26eafc2fae6912fb.woff";